import React, { useState } from 'react'
import { Box, Checkbox, Button, Grid } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Divider from '@material-ui/core/Divider'
import DownloadSummary from './DownloadSummary'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '@configurator-messages'
import { Formik, Field, Form } from 'formik'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import * as yup from 'yup'
import ValidationErrors from '../../../../validations/ValidationErrors'
import { ConfiguratorProductDetails } from '../../../ConfiguratorSharedTypes'
import { biTubeConfigContext } from '../../BiTube'
import { BitubeProperties, ErrorMessage, ActiveLinkType } from '../../enum'
import { priceFormatter } from '@src/routes/Configurators/utils/PriceFormatter'
import AddToCartItems from '@src/routes/Configurators/components/AddToCart/AddToCartItems'
import {
  useConfAddToMiniCartMutation,
  useSessionFieldsMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import { EMPTY_SESSION } from '../../EmptySession'
import {
  SnackbarType,
  useGlobalSnackbar,
} from '@src/components/GlobalSnackbar/globalSnackBarContext'
import { useRouter, fastDuplexOligosRoute, loginRoute } from '@src/routes'
import {
  convertToASCII,
  getConfiguratorGAdata,
  validateSurrogateCharacters,
} from '@src/routes/Configurators/utils/util'
import CircleLoader from '@src/components/CircleLoader'
import {
  handleGAAddToCartForConfigurator,
  handleGAAddToCartErrorsForConfigurator,
} from '@utils/analytics/configuratorAnalytics'
import {
  ProductNames,
  ConfiguratorValues,
} from '@src/routes/Configurators/utils/constants'
import { CountryCodes } from '@src/routes/Configurators/products/DnaPlates/enum'
import useDebounce from '@src/routes/Configurators/utils/ConfiguratorDebounce'
import { TubeProperties } from '../../../../utils/enum'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: 'white',
      padding: theme.spacing(5, 5),
    },
    dJustifyFlexEnd: {
      justifyContent: 'flex-end',
    },
    dFlex: {
      display: 'flex',
    },
    w100: {
      width: '100%',
    },
    mgBottom3: {
      marginBottom: theme.spacing(3),
    },
    mgLeft: {
      marginLeft: '35%',
    },
    mgBottom: {
      marginBottom: theme.spacing(5),
    },
    dFlexDirectionRowReverse: {
      flexDirection: 'row-reverse',
    },
    additionalInfoText: {
      resize: 'none',
      fontFamily: 'inherit',
      '& textarea': {
        overflow: 'auto',
      },
    },
    font12: {
      fontSize: theme.typography.pxToRem(12),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(0, 0, 3),
    },
    subTotal: {
      marginBottom: theme.spacing(5),
      display: 'flex',
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightMedium,
    },
    shippingInfo: {
      fontSize: theme.typography.pxToRem(16),
      marginBottom: theme.spacing(5),
    },
    shippingNote: {
      marginBottom: theme.spacing(5),
      fontSize: theme.typography.pxToRem(12),
    },
    shippingNoteMirna: {
      fontWeight: theme.typography.fontWeightBold,
    },
    uploadDisable: {
      backgroundColor: theme.palette.grey[500],
    },
    summaryOutline: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    fontQuote: {
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightBold,
    },
  }
})

interface BiTubeDetailsForGA {
  productDetails: any
  totalQuantity: number
  price: string
  productName: string
}

interface SummaryOrderProps {
  productDetails: ConfiguratorProductDetails
  updateError: any
  itemDetails: any
}
interface ConfiguratorAddToMiniCart {
  productType: string
  participantId: string
  countryCode: string
  locale: string
  sapNextEnabled: boolean
  timeZone: string
  store: string
}
const SummaryOrder: React.FC<SummaryOrderProps> = (props) => {
  const classes = useStyles()
  const [callDebounceCall, setCallDebounceCall] = React.useState(false)
  const [price, setPrice] = useState<string>('')
  const intl = useIntl()
  const [validationErrors, setValidationErrors] = useState<string[]>([])
  let [splChar] = ''
  const { productDetails, updateError, itemDetails } = props
  const { bitubeState, biTubeDispatch } = React.useContext(biTubeConfigContext)
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [totalPrice, setTotalPrice] = useState<string>('')
  const [totalItem, setTotalItem] = useState<number>(0)
  const { sessionData, productInformation, isSessionLoaded } = bitubeState
  const [additionalComments, setAdditionalComments] = React.useState(
    sessionData[0].additionalComments
  )
  const [commentsCheckBox, setCommentsCheckBox] = React.useState(false)
  const [isUpdateCart, setIsUpdateCart] = useState<boolean>(false)
  let { companionProducts } = productInformation
  companionProducts =
    companionProducts && companionProducts[0] !== '' ? companionProducts : null
  const [disableUpload, setDisableUpload] = React.useState(false)
  const debouncedAdditionalData = useDebounce(
    additionalComments,
    TubeProperties.SEQUENCE_API_TIME
  )
  const { setGlobalSnackbarState } = useGlobalSnackbar()
  const [addMiniCart, { data, loading }] = useConfAddToMiniCartMutation({
    // refetchQueries: [
    //   {
    //     query: QUICK_CART,
    //     variables: { id: CartRequestAction.Mini },
    //   },
    // ],
    // awaitRefetchQueries: true,
  })

  const sequencePath = `${fastDuplexOligosRoute.index()}?product=${
    productDetails.productType
  }&activeLink=${ActiveLinkType.SequenceEntry}`

  const router = useRouter()

  const configuratorAddToMiniCart: ConfiguratorAddToMiniCart = {
    productType: productDetails.productType,
    countryCode: productDetails.countryCode,
    participantId: productDetails.participantId,
    locale: productDetails.locale,
    sapNextEnabled: productDetails.sapNextEnabled,
    timeZone: productDetails.timeZone,
    store: productDetails.store,
  }
  const { sapNextEnabled } = configuratorAddToMiniCart

  //configuring the Configurator product data for sending it to GA
  const product = router?.query?.product ?? ''
  const itemName = ProductNames[product]
  const qty = sessionData?.length
  const configProductDetails: BiTubeDetailsForGA = getConfiguratorGAdata(
    itemDetails,
    sessionData,
    itemName,
    qty,
    productDetails.locale,
    productInformation.currencyFormat
  )

  const handleAddToCart = async () => {
    await addMiniCart({
      variables: { input: configuratorAddToMiniCart },
      fetchPolicy: 'no-cache',
    })
  }

  const clearSessionData = () => {
    sessionData[0].applyToAll = false
    biTubeDispatch({
      type: 'UPDATE_OLIGO_INDEX',
      data: 0,
    })
    biTubeDispatch({
      type: 'UPDATE_CURRENT_OLIGO_INDEX',
      data: 0,
    })
    biTubeDispatch({
      type: 'UPDATE_INPUT',
      data: [EMPTY_SESSION],
    })
  }

  const setLength = (): number => {
    let lengthOfComment = 0
    let maxLength = 0
    sessionData.forEach((data) => {
      if (data.comments && data.comments.length > lengthOfComment) {
        lengthOfComment = data.comments.length
      }
    })
    if (sapNextEnabled) {
      maxLength = 999 - lengthOfComment
    } else {
      maxLength = 90 - lengthOfComment
    }
    return maxLength
  }

  //function to extract the special characters from the string passed
  const checkSpecialChar = (args): string => {
    splChar = ''
    args.value.split('').forEach((c) => {
      if (c.match(/^[~!@$^|{}?<>&%—’'"]*$/) && !splChar.includes(c)) {
        if (splChar === '') {
          splChar = c
        } else {
          splChar = splChar + ', ' + c
        }
      }
    })
    return splChar
  }

  const handleComments = (value) => {
    setCallDebounceCall(true)
    setAdditionalComments(value)
    sessionData.forEach((bitube) => {
      bitube.additionalComments = value
    })
    biTubeDispatch({
      type: 'UPDATE_INPUT',
      data: [...bitubeState.sessionData],
    })
  }

  const handleCommentsOnChange = (value, isSessionLoaded) => {
    value = convertToASCII(value)
    if (isSessionLoaded) {
      handleComments(value)
    }
    const val = checkSpecialChar({ value })
    const surrogateCharacters = validateSurrogateCharacters(value)
    let invalidcharExist = false
    const validator = yup
      .string()
      .max(
        setLength(),
        intl.formatMessage(messages.CONF_ADD_INFO_MAX_VALIDATION_MSG) +
          setLength()
      )
      .matches(
        /^[^~!@$^|{}?<>&%—’'"]*$/,
        `${intl.formatMessage(messages.CONF_SPL_CHAR_VALIDATION_MSG)} ${val}`
      )
    const errors: string[] = []
    try {
      if (surrogateCharacters.length !== 0) {
        setValidationErrors([
          `${intl.formatMessage(
            messages.CONF_SPL_CHAR_VALIDATION_MSG
          )} ${surrogateCharacters}`,
        ])
        updateError(true)
        biTubeDispatch({ type: 'IS_SIDE_NAV_DISABLE', data: true })
        setDisableUpload(true)
      } else {
        setValidationErrors([])
        updateError(false)
        biTubeDispatch({ type: 'IS_SIDE_NAV_DISABLE', data: false })
        biTubeDispatch({ type: 'SET_PAGE_ERROR', data: '' })
        setDisableUpload(false)
      }
      validator.validateSync(value, {
        abortEarly: false,
      })
    } catch (error: any) {
      for (const err of error.errors) {
        if (
          err.includes(
            intl.formatMessage(messages.CONF_SPL_CHAR_VALIDATION_MSG)
          )
        ) {
          surrogateCharacters.length !== 0
            ? errors.push(err + ', ' + surrogateCharacters)
            : errors.push(err)
          invalidcharExist = true
        } else {
          errors.push(err)
        }
      }
      if (!invalidcharExist && surrogateCharacters.length !== 0) {
        errors.push(
          `${intl.formatMessage(
            messages.CONF_SPL_CHAR_VALIDATION_MSG
          )} ${surrogateCharacters}`
        )
      }
      setValidationErrors(errors)
      updateError(true)
      biTubeDispatch({ type: 'IS_SIDE_NAV_DISABLE', data: true })
      setDisableUpload(true)
    }
    return undefined
  }

  const calculatePrice = () => {
    let totalPrice = 0
    let isPriceValid = true
    sessionData.forEach((data) => {
      if (
        data.price &&
        data.price !== BitubeProperties.Quote &&
        data.price !== '--'
      ) {
        totalPrice = totalPrice + parseFloat(data.price)
      } else if (data.price === BitubeProperties.Quote) {
        setPrice(intl.formatMessage(messages._PC_QUOTE_ITEM))
        isPriceValid = false
      } else {
        setPrice('--')
        isPriceValid = false
      }
    })
    if (isPriceValid) {
      const formattedPrice = priceFormatter(
        totalPrice,
        productInformation.currencyFormat,
        productInformation.thousandSeparator,
        productInformation.thousandSpacing,
        productInformation.decimalSeparator,
        productInformation.prefixCurrecny,
        sessionData[0].currencySymbol
      )
      const priceData = formattedPrice
      setPrice(priceData)
    }
    if (
      sessionData[0].additionalComments !== null &&
      sessionData[0].additionalComments !== undefined &&
      sessionData[0].additionalComments.length > 0
    ) {
      setCommentsCheckBox(true)
      setAdditionalComments(sessionData[0].additionalComments)
      handleCommentsOnChange(sessionData[0].additionalComments, false)
    }
  }
  const [sessionFields] = useSessionFieldsMutation()
  const sessionDataToSession = async (obj) => {
    await sessionFields({
      variables: { input: obj, productInput: productDetails },
    })
  }
  React.useEffect(
    () => {
      if (callDebounceCall) {
        setCallDebounceCall(false)
        sessionDataToSession(sessionData)
      }
    },
    // TODO: need a test before we refactor these dependencies

    [debouncedAdditionalData]
  )

  React.useEffect(() => {
    if (data?.confAddToMiniCart?.result !== BitubeProperties.Success) {
      calculatePrice()
    }
    setTotalPrice(price)
    const cartItems = sessionData.filter((tube) => {
      return tube?.cartId?.length && tube?.itemId?.length
    })
    if (!isUpdateCart)
      // added for STRAT-18888 2nd Observation
      cartItems.length ? setIsUpdateCart(true) : setIsUpdateCart(false)
    // TODO: need a test before we refactor this
  }, [sessionData])

  React.useEffect(() => {
    const errorMessage = ConfiguratorValues.AddToCartFail
    if (data) {
      if (data?.confAddToMiniCart?.serverError) {
        updateError(ConfiguratorValues.AddToCartFail)
        window.scrollTo(0, 0)
        //GAtracking event on button click of addToCart.
        handleGAAddToCartErrorsForConfigurator(
          configProductDetails,
          errorMessage
        )
      } else {
        if (data?.confAddToMiniCart?.result === BitubeProperties.Success) {
          //GAtracking event on button click of addToCart
          handleGAAddToCartForConfigurator(configProductDetails)
          setTotalPrice(price)
          setTotalItem(sessionData.length)
          setDialogOpen(true)
        } else if (
          data?.confAddToMiniCart?.result === ErrorMessage.SessionDataEmpty
        ) {
          clearSessionData()
          router.push(sequencePath)
        } else if (
          data?.confAddToMiniCart?.result === ErrorMessage.AccessTokenExpire
        ) {
          router.push(loginRoute.index())
          setGlobalSnackbarState({
            open: true,
            message: (
              <FormattedMessage
                {...messages.USER_NOT_AUTHORIZED_OR_TOKEN_EXPIRED}
              />
            ),
            variant: SnackbarType.Error,
          })
        } else {
          updateError(ConfiguratorValues.AddToCartFail)
          handleGAAddToCartErrorsForConfigurator(
            configProductDetails,
            errorMessage
          )
        }
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [data])

  React.useEffect(() => {
    if (isSessionLoaded) {
      const hasProductData = sessionData.find((item) => item.antisenceName)
      if (!hasProductData) {
        router.push(sequencePath)
      } else {
        if (
          sessionData[0].additionalComments !== null &&
          sessionData[0].additionalComments !== undefined &&
          sessionData[0].additionalComments.length > 0
        ) {
          setCommentsCheckBox(true)
          handleCommentsOnChange(sessionData[0].additionalComments, false)
          setAdditionalComments(sessionData[0].additionalComments)
        }
      }
    }
  }, [isSessionLoaded])

  const handleAknowledgeCheckBox = (value) => {
    setCommentsCheckBox(value)
    if (!value) {
      handleComments('')
      setDisableUpload(false)
      updateError(false)
      setValidationErrors([])
      biTubeDispatch({ type: 'IS_SIDE_NAV_DISABLE', data: false })
      biTubeDispatch({ type: 'SET_PAGE_ERROR', data: '' })
    }
  }

  return (
    <div className={classes.summaryOutline}>
      <DownloadSummary productDetails={productDetails} />
      <div
        className={clsx(
          classes.contentWrapper,
          classes.dFlex,
          classes.dFlexDirectionRowReverse
        )}
      >
        <Box>
          <div className={classes.w100}>
            <div className={clsx(classes.mgBottom3, classes.font12)}>
              <h2 className={classes.subHead}>
                <FormattedMessage {...messages.CART_SUMMARY} />
              </h2>
              <Divider />
            </div>

            <Grid container className={classes.subTotal}>
              <Grid item xs={4} sm={4}>
                <FormattedMessage
                  id="CART_SUBTOTAL"
                  defaultMessage="Subtotal"
                />
                :
              </Grid>
              <Grid
                item
                xs={8}
                sm={8}
                className={clsx(
                  classes.dFlex,
                  classes.w100,
                  classes.dJustifyFlexEnd
                )}
              >
                {price}
              </Grid>
            </Grid>
            <div className={classes.shippingInfo}>
              <span>
                <strong>
                  <FormattedMessage {...messages.SHIPPING} />:{' '}
                </strong>
                <span>
                  <FormattedMessage {...messages.CONF_AMBIENT_ROOM_TEMP} />
                </span>
              </span>
            </div>
            <div className={classes.shippingNote}>
              {price === intl.formatMessage(messages._PC_QUOTE_ITEM) ? (
                <span className={classes.fontQuote}>
                  <FormattedMessage {...messages.CART_QUOTATION_TEXT} />{' '}
                </span>
              ) : (
                <>
                  <strong>
                    <FormattedMessage
                      id="CART_ITEM_NOTE"
                      defaultMessage="Note"
                    />
                    :{' '}
                  </strong>
                  <FormattedMessage {...messages.CONF_PRICE_SUB_TOTAL} />
                </>
              )}
              <ul>
                <li>
                  <FormattedMessage {...messages.CONF_APPLICATIONFREIGHT_TAX} />
                </li>
                <li>
                  <FormattedMessage {...messages.CONF_PROMOTIONAL_CODES} />
                </li>
              </ul>
            </div>
            {CountryCodes.JP === productDetails.countryCode ? (
              ''
            ) : (
              <>
                <div>
                  <h3>
                    <FormattedMessage
                      {...messages.CONF_ADDITIONAL_SHIPPING_INFO}
                    />
                  </h3>
                </div>
                <div className={classes.font12}>
                  <Checkbox
                    checked={commentsCheckBox}
                    value={commentsCheckBox}
                    color="primary"
                    onChange={() => {
                      handleAknowledgeCheckBox(!commentsCheckBox)
                    }}
                  />
                  <FormattedMessage {...messages.CONF_ACKNOWLEDGE_DNA_PLATES} />
                </div>

                <Formik
                  initialValues={{ addInfo: '' }}
                  validateOnChange={false}
                  onSubmit={(values, actions) => {
                    setTimeout(() => {
                      actions.setSubmitting(false)
                    }, 1000)
                  }}
                >
                  {
                    <Form>
                      <div className={clsx(classes.mgBottom, classes.font12)}>
                        <Field
                          name="addInfo"
                          component={LiquidInputAdapter}
                          placeholder={intl.formatMessage(
                            messages.CONF_ENTER_ADDITIONAL_INFO
                          )}
                          multiline
                          spellCheck={'false'}
                          rows={6}
                          rowsMax={30}
                          filled
                          className={clsx(
                            classes.w100,
                            classes.additionalInfoText
                          )}
                          disabled={!commentsCheckBox}
                          value={additionalComments}
                          onChange={(e) => {
                            handleCommentsOnChange(e.target.value, true)
                          }}
                          inputProps={{
                            'data-scrub': 'true',
                          }}
                        />
                        <ValidationErrors errors={validationErrors} />
                      </div>
                    </Form>
                  }
                </Formik>
              </>
            )}

            <div className={clsx(classes.w100, classes.font12)}>
              <Button
                variant="contained"
                color="primary"
                className={clsx(
                  classes.w100,
                  disableUpload && classes.uploadDisable
                )}
                disabled={loading || disableUpload}
                onClick={handleAddToCart}
                data-testid="summary-order-update-cart-or-add-to-cart"
                id="summary-order-update-cart-or-add-to-cart"
              >
                {isUpdateCart ? (
                  <FormattedMessage {...messages.UPDATE_CART} />
                ) : (
                  <FormattedMessage
                    id="ADD_TO_CART"
                    defaultMessage="Add to Cart"
                  />
                )}
              </Button>
            </div>
            <AddToCartItems
              dialogOpen={dialogOpen}
              setDialogOpen={setDialogOpen}
              price={totalPrice}
              totalItem={totalItem}
              companionProducts={companionProducts}
              productType={productDetails.productType}
            />
          </div>
        </Box>
      </div>
      {loading && <CircleLoader />}
    </div>
  )
}
export default SummaryOrder
